@if (idTag(); as idTag) {
  <h2 mat-dialog-title>
    @if (idTagActiveOnInit) {
      <mat-icon svgIcon="block" class="icon-24"></mat-icon>
      Fjern adgang
    } @else {
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
      Giv adgang
    }
  </h2>
  <button class="btn-close btn-icon" mat-dialog-close>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
  <mat-dialog-content>
    @if (statusChangeDone) {
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
        <div>
          <ok-feedback-success> Brikken er nu aktiv </ok-feedback-success>
        </div>
      }
      @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
        <div>
          <ok-feedback-fail> Brikken har nu fået fjernet adgang til organisationens ladepunkter </ok-feedback-fail>
        </div>
      }
      <p>Du kan nu lukke dette vindue.</p>
    }

    @if (!statusChangeDone && idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
      <div class="med-text margin--bottom-l">Er du sikker på du vil fjerne brikkens adgang til organisationens ladepunkter?</div>
      <ok-feedback-info>
        <div>
          <strong>Hvad sker der når adgangen fjernes?</strong><br />
          Alle start af nye ladninger på organisationens ladepunkter vil blive afvist. Du har mulighed for at give adgang til organisationen
          igen.
        </div>
      </ok-feedback-info>
    }

    @if (!statusChangeDone && idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
      <div class="med-text margin--bottom-l">
        Er du sikker på du vil give brikken "{{ idTag.description }}" adgang til organisationens ladepunkter igen?
      </div>
      <ok-feedback-info>
        <div>
          <strong>Hvad sker der når adgang gives?</strong><br />
          Når adgangen er givet, kan brikken bruges på alle organisationens ladepunkter.
        </div>
      </ok-feedback-info>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="unit-identifier">
      <span>Brik ID:</span>
      {{ idTag.printedId }}
    </div>

    @if (statusChangeDone) {
      <button class="actions__button" type="button" [disabled]="saving" mat-flat-button color="primary" (click)="cancel()">Luk</button>
    }

    @if (!statusChangeDone) {
      <button class="actions__button margin--right-2" type="submit" mat-button (click)="cancel()">Annuller</button>
    }

    @if (
      !statusChangeDone && (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active] || idTag.status === idTagStatusEnum.Active)
    ) {
      <button
        class="actions__button"
        type="button"
        [disabled]="saving"
        [class.spinner]="saving"
        mat-flat-button
        color="primary"
        (click)="toggleIdTag(idTag)">
        Fjern adgang
      </button>
    }
    @if (
      !statusChangeDone &&
      (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup] || idTag.status === idTagStatusEnum.Blocked)
    ) {
      <button
        class="actions__button"
        type="button"
        [disabled]="saving"
        [class.spinner]="saving"
        mat-flat-button
        color="primary"
        (click)="toggleIdTag(idTag)">
        Giv adgang
      </button>
    }
  </mat-dialog-actions>
}
